import React, { useState, useEffect } from 'react'
import { Form } from 'react-final-form'
import TextField from '../../molecules/fields/TextField'
import { Button } from '../../atoms/Button'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { FORM_ERROR } from 'final-form'
import { useAuth } from '../../molecules/Auth'
import ErrorValidationMessage from '../../molecules/ErrorValidationMessage'
import PublicFooter from '../../organisms/footer/PublicFooter'
import SupportMessage from '../../molecules/SupportMessage'
import * as validations from '../../../utils/validations'

const VerifyEmail = () => {
  const history = useHistory()
  const { user, getUser, logout } = useAuth()
  const [canResend, setCanResend] = useState(true)
  const [resendTimer, setResendTimer] = useState(0)

  useEffect(() => {
    if (!user?.needs_email_verification) {
      if (user?.needs_password_change) {
        history.replace('/cambiar-contrasena')
      } else {
        history.replace('/formularios')
      }
    }
  }, [user])

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000)
      return () => clearTimeout(timer)
    } else {
      setCanResend(true)
    }
  }, [resendTimer])

  const handleVerifyEmail = async values => {
    try {
      const response = await axios.post('/admin/v1/account/verify_email', values)
      await getUser()
      const nextStep = response.data?.next_step
      if (nextStep === 'change_password') {
        history.push('/cambiar-contrasena')
      } else {
        history.push('/formularios')
        localStorage.setItem('showFormStartMessage', 'true')
      }
    } catch (error) {
      return { [FORM_ERROR]: error.response?.data?.error || 'Error al verificar el correo' }
    }
  }

  const handleResendCode = async () => {
    if (!canResend) return
    try {
      await axios.post('/admin/v1/account/send_verification_code')
      setCanResend(false)
      setResendTimer(60)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error resending code', error)
    }
  }

  const handleCancel = () => {
    logout().then(() => {
      history.push('/')
    })
  }

  return (
    <>
      <div className="flex-1 md:flex items-center justify-center">
        <div className="px-6 pt-8 md:py-16 md:flex items-center justify-center w-full max-w-lg">
          <div className="m-auto w-full">
            <Form onSubmit={handleVerifyEmail}>
              {({ handleSubmit, submitError, submitting, pristine }) => (
                <form
                  onSubmit={handleSubmit}
                  className="bg-white p-6 lg:p-10 shadow-card-login items-center justify-center"
                >
                  <h2 className="font-bold text-xl mb-6">Verificación de correo</h2>
                  <p className="mb-4">
                    Hemos enviado un código de verificación a <strong>{user?.email}</strong>
                  </p>
                  <TextField
                    name="code"
                    label="Código de verificación"
                    size="full"
                    labelClassName="text-base"
                    validate={validations.required()}
                  />

                  {submitError && <ErrorValidationMessage className="max-w-fit mb-6" error={submitError} />}

                  <Button disabled={submitting || pristine} type="submit" size="full" className="m-auto mb-4">
                    Verificar
                  </Button>

                  <div className="text-center">
                    <button
                      type="button"
                      onClick={handleResendCode}
                      disabled={!canResend}
                      className={`font-bold ${
                        !canResend ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 hover:text-blue-800'
                      }`}
                    >
                      {canResend ? 'Reenviar código' : `Reenviar código en ${resendTimer}s`}
                    </button>
                  </div>

                  <div className="text-center mt-4">
                    <button
                      type="button"
                      onClick={handleCancel}
                      className="text-gray-500 hover:text-gray-700 text-sm underline"
                    >
                      Cancelar
                    </button>
                  </div>
                </form>
              )}
            </Form>
            <SupportMessage />
          </div>
        </div>
      </div>
      <PublicFooter />
    </>
  )
}

export default VerifyEmail
